<template>
  <div
    class="navbar-sidemenu-link"
    :class="{ active: isActive }"
    :style="dynamicStyle"
    @click="$emit('click')"
  >
    <div class="active-badge" v-if="isActive"></div>
    <img class="image-icon" :src="target.imageIcon" v-if="target.imageIcon" />
    <BaseIcon size="sm" :icon="target.leftIcon" v-if="target.leftIcon" />
    <div class="qrw-label-md bold w-100">
      {{ target.title || $t("navbar." + target.name) }}
      <span class="qrw-text-content-error-primary regular" v-if="target.betaBadge">
        (beta)
      </span>
    </div>
    <div class="notification-badge qrw-label-sm bold" v-if="target.notification">
      {{ target.notification }}
    </div>
    <BaseIcon size="sm" :icon="target.rightIcon" v-if="target.rightIcon" />
    <div class="system-badge qrw-label-badge qrw-label-sm" :class="{
      [systemBadge]: true,
    }" v-if="systemBadge">
      {{ systemBadge }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    target: Object,
  },
  computed: {
    isActive() {
      return this.$route.name === this.target.name;
    },
    systemBadge() {
      return this.target &&  this.target.systemBadge;
    },
    dynamicStyle() {
      return {
        color: this.target.color ? `var(--qrw-${this.target.color})` : null,
      };
    },
  },
};
</script>

<style scoped>
.navbar-sidemenu-link {
  display: flex;
  flex-direction: row;
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 10px;
  align-items: center;
  color: var(--qrw-content-base-inverse-secondary);
  column-gap: 6px;
  position: relative;
}

.navbar-sidemenu-link:hover,
.navbar-sidemenu-link.active {
  background: var(--qrw-background-overlay-a10);
  color: var(--qrw-content-base-inverse-primary);
}

.active-badge {
  width: 2px;
  height: calc(100% - 24px);
  display: block;
  background: var(--qrw-content-base-inverse-primary);
  border-radius: 1px;
  position: absolute;
  transform: translateX(-8px);
}

.image-icon {
  width: 20px;
  height: 20px;

  display: block;
  object-fit: cover;
  max-width: 20px;
  border-radius: 4px;
}

.notification-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--qrw-content-base-inverse-primary);
  background: var(--qrw-background-error-default);
  border-radius: 4px;
  padding: 2px 7px;
  text-align: center;
  box-sizing: border-box;
  width: 20px;
  height: 20px;

  position: absolute;
  top: 10px;
  right: 10px;
}

.system-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 2px 6px;
  box-sizing: border-box;
}

.system-badge.on {
  color: var(--foundation-success-400-color);
  background: var(--foundation-success-900-color);
}

.system-badge.off {
  color: var(--foundation-error-400-color);
  background: var(--foundation-error-900-color);
}
</style>
